import { guestClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { UnsubscribeQuerySchema } from './schemas.js';

export const unsubscribe = guestClient.mutation({
  url: 'datintell/v1/external_integrations/unsubscribe/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: UnsubscribeQuerySchema,
  processResponse(data) {
    return data;
  },
});
